import { useState, useEffect } from "react";
import {
    Box,
    Paper,
    Typography,
    ListItem,
    ListItemButton,
    ListItemText,
    FormControl,
    Select,
    MenuItem,
    InputLabel
} from "@mui/material";
import LoadingCircle from "../../../components/LayoutComponents/LoadingCircle";
import SkillProfileForm from "./SkillProfileForm";
import {createSkillProfile, updateSkillProfile, deleteSkillProfile, createSkillProfileSkills, getSkillProfileSkills, updateSkillProfileSkills, requestSkillProfiles} from "../../../remote/skillProfileRequest"
import theme from "../../../components/LayoutComponents/theme";

export default function SkillProfiles({ session, competencies, proficiencies, companies, skillProfiles, setSkillProfiles }) {

    const [selected, setSelected] = useState(null);
    const [selectedCompany, setSelectedCompany] = useState("")
    const [skills, setSkills] = useState(null);
    const initialFormData = {
        profileId: 0,
        profileName: "",
        profileDescription: "",
        dutiesResponsibilities: "",
        industryId: null,
        effectiveStartDate: null,
        effectiveEndDate: null,
        activeFlag: false,
        entityId: null
    }
    const [formData, setFormData] = useState(initialFormData)
    const [loading, setLoading] = useState(false)

     useEffect(() => {
            if (!session?.token) return;
            const loadSkills = async () => {
                if (selected?.profileId) {
                    try {
                        setLoading(true)
                        const response = await getSkillProfileSkills(session?.token, selected.profileId);
                        setSkills(response.data || []);
                    } catch (error) {
                        console.error("Error fetching job profile skills:", error);
                    } finally {
                        setLoading(false)
                    }
                } else {
                    setSkills([]);
                }
            };
    
            if (session?.token && selected?.profileId !== 0) {
                loadSkills();
            }
        }, [session?.token, selected?.profileId]);
    
        const handleSave = async () => {
                let resProf
                let resSkill
                try {
                    setLoading(true)
                    if (formData?.profileId === 0) {
                            resProf = await createSkillProfile(session?.token, formData)
                            resSkill = await createSkillProfileSkills(session?.token, resProf.data.profileId, skills)
                            setSkills(resSkill.data) 
                            setSkillProfiles(prev => [resProf.data, ...prev]);
                    } else {
                        await updateSkillProfile(session?.token, formData)
                        await updateSkillProfileSkills(session?.token, selected?.profileId, skills)
                        resProf = await requestSkillProfiles(session?.token)
                        setSkillProfiles(resProf.data || []);
                    }
                } catch (err) {
                    console.error("Error saving profile", err);
                } finally {
                    setLoading(false)
                }
            };

            const handleDelete = async () => {
                    try {
                        setLoading(true)
                        let res =  await deleteSkillProfile(session?.token, selected?.profileId)
                        setSkillProfiles(res.data);
                        setSelected(null);
                        setFormData(initialFormData);
                    } catch (err) {
                        console.error("Error deleting skill profile", err);
                    } finally {
                        setLoading(false)
                    }
                }


    return (
        <>
        <Box sx={{ display: "flex", gap: 3, width: "100%", alignItems: "flex-start" }}>
            <Paper
                sx={{
                    width: "25%",
                    p: 2,
                    height: "60vh",
                    overflowY: "auto",
                }}
            >
                <Typography
                    variant="h6"
                    sx={{ mb: 2, color: theme.colors.purple, textAlign: "center" }}
                >
                    Skill Profiles
                </Typography>
                <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                    <InputLabel>Filter by Company</InputLabel>
                    <Select
                        value={selectedCompany ?? ""}
                        label="Filter by Company"
                        onChange={(e) => setSelectedCompany(Number(e.target.value))}
                    >
                        <MenuItem value="">All</MenuItem>
                        {companies?.map((company) => (
                            <MenuItem key={company.entityId} value={company.entityId}>
                                {company.entityName}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {skillProfiles?.length > 0 || !loading ?
                    skillProfiles
                        ?.filter(t => !selectedCompany || t.entityId === selectedCompany)
                        ?.sort((a, b) => a.profileName.toLowerCase().localeCompare(b.profileName.toLowerCase()))
                        .map((profile) => (
                            <ListItem key={profile.profileId} disablePadding>
                                <ListItemButton
                                    selected={selected?.profileId === profile.profileId}
                                    onClick={() => {
                                        setSelected(profile);
                                        setFormData(profile);
                                    }}
                                >
                                    <ListItemText primary={profile?.profileName} />
                                </ListItemButton>
                            </ListItem>
                        )) : <Box sx={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}><LoadingCircle size={20} /></Box>}
            </Paper>
            <Box sx={{ flex: 1, minWidth: 600 }}>
                <SkillProfileForm
                    onSave={handleSave}
                    onDelete={handleDelete}
                    session={session}
                    competencies={competencies}
                    proficiencies={proficiencies}
                    formData={formData}
                    setFormData={setFormData}
                    loading={loading}
                    companies={companies}
                    skills={skills}
                    setSkills={setSkills}
                />
            </Box>
        </Box>
        </>

    )
}